/* ============================================================
   skinmade — Cream PDP Login-Gate + Hautanalyse-Gate + Custom ATC
   - Variant-ID via Product-JSON-Lookup (verhindert GP-Form-Mismatch)
   - Cart-Drawer via Symmetry's "theme:cartchanged" Event
   - Gate: eingeloggt (SmLogin) UND Hautanalyse (SmSkin) nötig
   ============================================================ */

(function () {
  'use strict';

  // Tag-gesteuerte Aktivierung: theme.liquid setzt window.SM_PRODUCT_REQUIRES_LOGIN
  // sowie window.SM_PRODUCT_HANDLE, sobald das aktuelle Produkt den Tag
  // "requires-login" trägt. Damit wird jedes neue personalisierte Produkt
  // automatisch durch das Gate geschützt, ohne JS-Anpassung.
  if (!window.SM_PRODUCT_REQUIRES_LOGIN || !window.SM_PRODUCT_HANDLE) return;

  var PRODUCT_HANDLE = window.SM_PRODUCT_HANDLE;
  var BOOK_URL = (location.pathname.indexOf('/en') === 0 ? '/en' : '') + '/pages/skinmade-partner-finden';

  var productData = null;
  var hasMultipleVariants = false;

  // Analyse-Status: sm-skin-gate.js setzt window.SmSkin (hasSkin/noSkin).
  // Solange nicht eingeloggt ODER ohne Analyse -> kein ATC.
  function skinOk() { return SmLogin.isVerified() && !!(window.SmSkin && window.SmSkin.hasSkin); }
  function noSkin() { return SmLogin.isVerified() && !!(window.SmSkin && window.SmSkin.noSkin); }

  function fetchProduct() {
    if (productData) return Promise.resolve(productData);
    return fetch('/products/' + PRODUCT_HANDLE + '.json')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        productData = data.product;
        hasMultipleVariants = !!(productData.variants && productData.variants.length > 1);
        return productData;
      });
  }

  function lookupVariantId(texturValue, duftValue) {
    if (!productData || !productData.variants) return null;
    function eq(a, b) { return (a || '').trim().toLowerCase() === (b || '').trim().toLowerCase(); }

    var positions = (productData.options || []).reduce(function (acc, o, i) {
      acc[o.name.toLowerCase()] = i + 1; return acc;
    }, {});
    var texturPos = positions['textur'] || 1;
    var duftPos = positions['duft'] || 2;

    var match = productData.variants.find(function (v) {
      return eq(v['option' + texturPos], texturValue) && eq(v['option' + duftPos], duftValue);
    });
    return match ? match.id : null;
  }

  function init() {
    // Erst product data holen, damit wir wissen ob das Produkt
    // einen Variant-Picker hat oder nicht (Default-Variant-Produkte
    // haben kein gp-product-variants Element im DOM).
    fetchProduct()
      .then(function () { tryInit(); })
      .catch(function (err) {
        console.warn('[SmCreamPdp] Product fetch failed, fallback init:', err);
        tryInit();
      });
  }

  function tryInit() {
    var attempts = 0;
    var MAX_ATTEMPTS = 60;

    function attempt() {
      var variants = document.querySelector('gp-product-variants');
      var atcContainer = document.querySelector('gp-product-button');
      var atcBtn = document.querySelector('.gp-button-atc');
      var form = document.querySelector('form[action*="/cart/add"]');

      // Bei Multi-Variant-Produkten ist der Variant-Picker pflicht.
      // Bei Single-Variant-Produkten muss nur der ATC-Button da sein.
      var needsVariants = hasMultipleVariants;
      var domReady = atcContainer && atcBtn && form && (!needsVariants || variants);

      if (!domReady) {
        // Standard-Theme-Fallback (kein GemPages-PDP, z.B. Summer Set):
        // hydrierten Standard-ATC gaten, sobald klar ist dass keine GP-DOM mehr kommt.
        var isGemPages = !!document.querySelector('gp-product-button, gp-product-variants, .gp-button-atc');
        var stdBtn = form && form.querySelector('[name="add"], button[type="submit"]');
        if (attempts >= 8 && !isGemPages && form && stdBtn) {
          if (document.getElementById('sm-cream-gate')) return;
          var buyArea = form.closest('.buy-buttons-row') || form;
          injectGate(buyArea);
          hijackStandard(stdBtn, form);
          (function () {
            function sync() { buyArea.style.display = skinOk() ? '' : 'none'; }
            sync();
            window.addEventListener('sm:login', sync);
            window.addEventListener('sm:logout', sync);
            window.addEventListener('sm:skin', sync);
          })();
          return;
        }
        if (++attempts < MAX_ATTEMPTS) { setTimeout(attempt, 100); return; }
        console.warn('[SmCreamPdp] DOM nicht bereit');
        return;
      }
      if (document.getElementById('sm-cream-gate')) return;

      var gateAnchor = variants || atcContainer;
      injectGate(gateAnchor);
      hijackAtc(atcBtn, form);

      function syncLockState() {
        // Variant-Picker + ATC nur sichtbar wenn eingeloggt UND Analyse vorhanden.
        var ok = skinOk();
        if (variants) variants.style.display = ok ? '' : 'none';
        atcContainer.style.display = ok ? '' : 'none';
        // KEIN Auto-Pre-Select — User muss aktiv Textur + Duft wählen,
        // sonst falsche Variante (reichhaltig/wasserlilie) silent im Cart.
      }
      syncLockState();
      window.addEventListener('sm:login', syncLockState);
      window.addEventListener('sm:logout', syncLockState);
      window.addEventListener('sm:skin', syncLockState);
    }
    attempt();
  }

  function injectGate(insertBeforeNode) {
    var gate = document.createElement('div');
    gate.id = 'sm-cream-gate';
    gate.innerHTML =
      '<div class="sm-cream-locked sm-show-when-not-verified">' +
        '<h3 class="sm-cream-locked__title">🔒 Personalisiert mit deiner Hautanalyse</h3>' +
        '<p class="sm-cream-locked__text">' +
          'Dieses Produkt wird genau auf dein Hautprofil abgestimmt produziert. Logge dich kurz mit deinen Hautanalyse-Daten ein.' +
        '</p>' +
        '<button id="sm-cream-login-btn" type="button" class="sm-btn sm-btn-primary sm-btn--large">Jetzt anmelden &rarr;</button>' +
        '<p class="sm-modal-hint">Noch keine Hautanalyse? <a href="' + BOOK_URL + '">Jetzt Termin buchen</a></p>' +
      '</div>' +
      '<div class="sm-cream-locked sm-show-when-noskin">' +
        '<h3 class="sm-cream-locked__title">🔒 Hautanalyse benötigt</h3>' +
        '<p class="sm-cream-locked__text">' +
          'Für dieses personalisierte Produkt brauchen wir deine aktuelle Hautanalyse. Buche deinen Termin bei einem skinmade-Partner in deiner Nähe.' +
        '</p>' +
        '<a href="' + BOOK_URL + '" class="sm-btn sm-btn-primary sm-btn--large">Hautanalyse buchen &rarr;</a>' +
      '</div>' +
      '<div class="sm-cream-greeting sm-show-when-skin">' +
        '<p class="sm-cream-greeting__text">' +
          'Hi <span data-sm-name>👋</span> ✨ Wir haben deine Hautanalyse — dein Produkt wird individuell für dich produziert.' +
        '</p>' +
      '</div>';
    insertBeforeNode.parentElement.insertBefore(gate, insertBeforeNode);

    document.getElementById('sm-cream-login-btn').addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      SmLogin.openModal({
        message: 'Damit wir deine Hautanalyse für dieses Produkt nutzen können, melde dich bitte kurz an.'
      });
    });
  }

  function hijackAtc(atcBtn, form) {
    atcBtn.addEventListener('click', function (e) {
      if (!SmLogin.isVerified()) {
        e.preventDefault();
        e.stopImmediatePropagation();
        SmLogin.openModal({
          message: 'Bitte melde dich an, bevor du dieses Produkt bestellst.'
        });
        return;
      }
      if (noSkin()) {
        e.preventDefault();
        e.stopImmediatePropagation();
        window.location.href = BOOK_URL;
        return;
      }
      e.preventDefault();
      e.stopImmediatePropagation();
      addCreamToCart(atcBtn, form);
    }, true);

    form.addEventListener('submit', function (e) {
      if (!SmLogin.isVerified()) return;
      if (noSkin()) {
        e.preventDefault();
        e.stopImmediatePropagation();
        window.location.href = BOOK_URL;
        return;
      }
      e.preventDefault();
      e.stopImmediatePropagation();
      addCreamToCart(atcBtn, form);
    }, true);
  }

  // Standard-Theme-Gate (kein GemPages): nur gaten, den nativen Theme-ATC
  // sonst durchlassen (keine GP-spezifische Variant-Auflösung).
  function hijackStandard(btn, form) {
    function guard(e) {
      if (!SmLogin.isVerified()) {
        e.preventDefault();
        e.stopImmediatePropagation();
        SmLogin.openModal({ message: 'Bitte melde dich an, bevor du dieses Produkt bestellst.' });
        return;
      }
      if (noSkin()) {
        e.preventDefault();
        e.stopImmediatePropagation();
        window.location.href = BOOK_URL;
        return;
      }
      // eingeloggt + Analyse -> nativer Theme-ATC übernimmt
    }
    btn.addEventListener('click', guard, true);
    form.addEventListener('submit', guard, true);
  }

  function triggerCartDrawer() {
    SmCart.openCartDrawer();
  }

  // Liest die aktuelle User-Auswahl aus dem GP-Variant-Picker.
  // GP rendert pro Variante mehrere DOM-Strukturen; daher Multi-Strategy.
  function readSelection() {
    var DEBUG = '[SmCreamPdp]';

    // ----- Strategy 1: Heading-Text "Textur: leicht" / "Duft: ohne Duft" -----
    // Robusteste Quelle, da GP die Headings synchron mit User-Click updated.
    var fromHeadings = readFromHeadings();
    console.log(DEBUG, 'Strategy 1 (headings):', fromHeadings);
    if (fromHeadings.textur && fromHeadings.duft) {
      return { textur: fromHeadings.textur, duft: fromHeadings.duft, src: 'headings' };
    }

    // ----- Strategy 2: Active-Class-Buttons -----
    var fromActive = readFromActiveButtons();
    console.log(DEBUG, 'Strategy 2 (active buttons):', fromActive);
    if (fromActive.textur && fromActive.duft) {
      return { textur: fromActive.textur, duft: fromActive.duft, src: 'active-buttons' };
    }

    // ----- Strategy 3: Radio-Inputs (mehrere Naming-Konventionen) -----
    var radioPatterns = [
      ['input[name="options[Textur]"]:checked', 'input[name="options[Duft]"]:checked'],
      ['input[name*="-options-Textur"]:checked', 'input[name*="-options-Duft"]:checked'],
      ['input[name*="Textur" i]:checked', 'input[name*="Duft" i]:checked']
    ];
    for (var i = 0; i < radioPatterns.length; i++) {
      var t = document.querySelector(radioPatterns[i][0]);
      var d = document.querySelector(radioPatterns[i][1]);
      console.log(DEBUG, 'Strategy 3.' + i, radioPatterns[i], '→', t && t.value, '/', d && d.value);
      if (t && d && t.value && d.value) {
        return { textur: t.value, duft: d.value, src: 'radio-' + i };
      }
    }

    // ----- Final Debug Dump -----
    console.warn(DEBUG, 'No selection found. DOM dump:');
    var allRadios = document.querySelectorAll('gp-product-variants input[type="radio"]');
    console.warn(DEBUG, 'All radios in gp-product-variants:', allRadios.length);
    allRadios.forEach(function (r, idx) {
      console.warn(DEBUG, '  [' + idx + ']', { name: r.name, value: r.value, checked: r.checked });
    });

    return null;
  }

  function readFromHeadings() {
    // GP rendert Heading wie "Textur: leicht" oder "Duft: ohne Duft".
    // Wir suchen alle Elemente die mit "Textur:" oder "Duft:" beginnen
    // und nehmen den LETZTEN Match (aktuellste DOM-Position),
    // weil GP manchmal Default-Headings + Live-Headings hat.
    var result = { textur: null, duft: null };
    var DEBUG_HEADINGS = [];
    var nodes = document.querySelectorAll(
      'gp-product-variants *, gp-product-info *, .gp-product-variant *, [class*="variant-name"]'
    );
    nodes.forEach(function (el) {
      // Nur Leaf-Elemente mit eigenem Text (max. 1 Inline-Child wie <span>)
      if (el.children && el.children.length > 1) return;
      var t = (el.textContent || '').trim();
      if (!t || t.length > 80) return;
      var m = t.match(/^Textur\s*:\s*(.+)$/i);
      if (m) {
        // Sichtbarkeit prüfen — verstecktes Element überspringen
        var rect = el.getBoundingClientRect();
        var visible = rect.width > 0 && rect.height > 0;
        DEBUG_HEADINGS.push({ kind: 'textur', value: m[1].trim(), visible: visible });
        if (visible) result.textur = m[1].trim();
      }
      m = t.match(/^Duft\s*:\s*(.+)$/i);
      if (m) {
        var rect2 = el.getBoundingClientRect();
        var visible2 = rect2.width > 0 && rect2.height > 0;
        DEBUG_HEADINGS.push({ kind: 'duft', value: m[1].trim(), visible: visible2 });
        if (visible2) result.duft = m[1].trim();
      }
    });
    console.log('[SmCreamPdp] All matched headings:', DEBUG_HEADINGS);
    return result;
  }

  function readFromActiveButtons() {
    var result = { textur: null, duft: null };
    // GP markiert active-Variant typisch via aria-checked, aria-pressed, oder class
    var sel = 'gp-product-variants [aria-checked="true"], ' +
              'gp-product-variants [aria-pressed="true"], ' +
              'gp-product-variants [data-selected="true"], ' +
              'gp-product-variants .is-active, ' +
              'gp-product-variants [class*="--active"], ' +
              'gp-product-variants [class*="--selected"]';
    var actives = document.querySelectorAll(sel);
    actives.forEach(function (el) {
      // Such nach Group-Context: über Parent finde "Textur" oder "Duft"
      var group = el.closest('[data-option-name], [data-option], gp-product-variant');
      var label = '';
      if (group) {
        var groupText = (group.textContent || '').trim();
        if (/textur/i.test(groupText)) label = 'textur';
        else if (/duft/i.test(groupText)) label = 'duft';
      }
      // Fallback: schau Sibling-Heading
      if (!label) {
        var prev = el.parentElement;
        while (prev && !label) {
          var ptext = (prev.previousElementSibling && prev.previousElementSibling.textContent || '');
          if (/textur/i.test(ptext)) label = 'textur';
          else if (/duft/i.test(ptext)) label = 'duft';
          prev = prev.parentElement;
        }
      }
      var value = (el.getAttribute('data-value') || el.getAttribute('value') ||
                   (el.textContent || '').trim()).trim();
      if (label === 'textur' && !result.textur) result.textur = value;
      if (label === 'duft' && !result.duft) result.duft = value;
    });
    return result;
  }

  // GP updated die URL mit ?variant=ID bei jedem User-Click → authoritative Quelle
  function getVariantIdFromUrl() {
    var match = window.location.search.match(/[?&]variant=(\d+)/);
    return match ? match[1] : null;
  }

  function addCreamToCart(btn, form) {
    // Single-Variant-Produkte (Default Title, kein Variant-Picker):
    // direkt die einzige Variante des Produkts in den Warenkorb legen.
    if (!hasMultipleVariants && productData && productData.variants && productData.variants.length === 1) {
      var defaultVariantId = productData.variants[0].id;
      var origDisabledSingle = btn.disabled;
      btn.disabled = true;
      SmCart.addToCart([{ id: defaultVariantId, quantity: 1 }])
        .then(function () { triggerCartDrawer(); })
        .catch(function (err) {
          console.error('[SmCreamPdp] ATC failed (single-variant):', err);
          alert('Fehler beim Hinzufügen zum Warenkorb. Bitte erneut versuchen.');
        })
        .then(function () { btn.disabled = origDisabledSingle; });
      return;
    }

    // Primary Source: URL ?variant=... (von GP gesetzt bei User-Click).
    // Die Radios sind veraltet (Default-State), Headings sync nicht zuverlässig.
    var variantId = getVariantIdFromUrl();
    console.log('[SmCreamPdp] variantId from URL:', variantId);

    if (!variantId) {
      // Fallback: Selection-Reader (Headings/Active/Radios) + Lookup
      var sel = readSelection();
      if (!sel) {
        alert('Bitte wähle erst Konsistenz und Duft aus.');
        return;
      }
      console.log('[SmCreamPdp] Fallback selection (src=' + sel.src + '):', sel);

      var origDisabled1 = btn.disabled;
      btn.disabled = true;
      fetchProduct()
        .then(function () {
          var resolvedId = lookupVariantId(sel.textur, sel.duft);
          if (!resolvedId) throw new Error('Variant nicht gefunden: ' + sel.textur + ' / ' + sel.duft);
          console.log('[SmCreamPdp] Resolved variantId from lookup:', resolvedId);
          return SmCart.addToCart([{ id: resolvedId, quantity: 1 }]);
        })
        .then(function () { triggerCartDrawer(); })
        .catch(function (err) {
          console.error('[SmCreamPdp] ATC failed:', err);
          alert('Fehler beim Hinzufügen zum Warenkorb. Bitte erneut versuchen.');
        })
        .then(function () { btn.disabled = origDisabled1; });
      return;
    }

    // Direct Path: URL hat Variant → ATC ohne Lookup
    var origDisabled = btn.disabled;
    btn.disabled = true;

    SmCart.addToCart([{ id: variantId, quantity: 1 }])
      .then(function () { triggerCartDrawer(); })
      .catch(function (err) {
        console.error('[SmCreamPdp] ATC failed:', err);
        alert('Fehler beim Hinzufügen zum Warenkorb. Bitte erneut versuchen.');
      })
      .then(function () { btn.disabled = origDisabled; });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
